import { Component, Input, OnInit } from '@angular/core';
import { MuToastService } from '../../sharedServices/mu-toast.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { ToastActions } from './mu-toast-componet-enum';

@Component({
  selector: 'app-mu-toast',
  templateUrl: './mu-toast.component.html',
  styleUrls: ['./mu-toast.component.sass'],
})
export class MuToastComponent implements OnInit {
  @Input() key: string;
  @Input() position: string;
  @Input() actionList: Actions<ToastActions, any>;
  styleClass: string;

  constructor(private toasterService: MuToastService) {
    /** */
  }

  ngOnInit(): void {
    this.showCustomClass();
  }

  /**
   * Call service prop toasterCustomClass
   * return void
   */

  showCustomClass(): void {
    this.toasterService.toasterCustomClass.subscribe((customClass: string) => {
      this.styleClass = customClass;
    });
  }

  /**
   * Click to link of toast
   * @param {unknown} data
   * return void
   */
  onClick(data: unknown): void {
    this.actionList.emit(ToastActions.CLICK_LINK, data);
  }
}
